'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CheckmarkCircle = require('./CheckmarkCircle');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CheckmarkCircle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/CheckmarkCircle/index.js
// module id = 1147
// module chunks = 1